export default __webpack_public_path__ + "static/media/oshadi.04c652a8.jpg";